"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _iconBase = _interopRequireDefault(require("../icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaCaretDown = function FaCaretDown(props) {
  return _react.default.createElement(_iconBase.default, props, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M1024 704q0 26-19 45l-448 448q-19 19-45 19t-45-19L19 749Q0 730 0 704t19-45 45-19h896q26 0 45 19t19 45z"
  })));
};

FaCaretDown.defaultProps = {
  viewBox: '0 0 1024 1896.083',
  height: '1em',
  width: '0.5401em'
};
FaCaretDown.displayName = 'FaCaretDown';
var _default = FaCaretDown;
exports.default = _default;